export { AtnDsTabDirective as Directive } from './tab.directive'
